import { gql } from '@apollo/client/core';

export const textBlockFragment = gql`
  fragment TextBlockFields on TextBlock {
    entryTitle
    text
    style
    alignment
    notes
  }
`;
